import type {Hotel, Meta} from '@/redux/v1/hotels/list/models';
import type {CrossBordersData} from '@/redux/v1/models';

export const FETCH_HOTELS = 'v1/hotels/list/FETCH_HOTELS';
export const FETCH_NEXT_HOTELS = 'v1/hotels/list/FETCH_NEXT_HOTELS';
export const FETCH_ALL_HOTELS = 'v1/hotels/list/FETCH_ALL_HOTELS';

type RequestMeta = {
  requestId: string;
};

// @TODO abstract via redux/types
export type FetchHotelsPending = {
  meta: RequestMeta;
};

export type FetchHotelsSuccess = {
  data: {
    id: string;
    paramHash: string;
    hotels: Array<Hotel>;
    crossBorders?: CrossBordersData;
    metaUnfiltered: Meta;
    metaFiltered: Meta;
    translations: Record<string, string>;
  };
  meta: RequestMeta;
};

export type FetchHotelsError = {
  error: unknown;
  meta: RequestMeta;
};
